import { CardData, TextureData, TextureStatesData } from "../../../types/types";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { SettingsItem } from "../options/SettingsItem";
import { AppSettings } from "../../managers/AppSettings";
import { Padding } from "../../../utils/Padding";
import { ResultsListItemBubbleColor } from "./ResultsListItem";
import { TrumpIconView } from "./TrumpIconView";
import { LabelButton } from "../../../ui/LabelButton";
import { TrumpSuit } from "../../state/TableStateMachine";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { CardsManager } from "../../managers/CardsManager";


export class HandsListItem 
    extends SettingsItem
    implements ISize
{
    protected labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;
    protected bgTextureData: TextureData;
    protected imgCards: Phaser.GameObjects.Image[];
    protected labelPadding: Padding = new Padding(0, 0, 5, 15);

    // delimiter line
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected hasDelimiterLine: boolean;
    protected delimiterLineAlpha: number;


    public Init(
        bgTextureData: TextureData = undefined,
        labelTextStyle: Phaser.Types.GameObjects.Text.TextStyle = undefined,
        delimiterLineAlpha: number,
    ): void
    {
        // adjust padding from sides
        // this.borderPadding.width = 0;

        this.bgTextureData = bgTextureData;
        this.labelTextStyle = labelTextStyle;
        this.delimiterLineAlpha = delimiterLineAlpha;

        this.size = new RectSize();
        this.imgCards = [];
    }

    public Build(): void
    {
        this.bg = this.scene.make.image({key:this.bgTextureData.texture, frame:this.bgTextureData.frame});
        // this.bg.name = "bg";
        this.bg.setOrigin(0);
        // this.bg.setScale(1.0);
        // this.bg.setData("baseScale", this.bg.scale);
        this.add(this.bg);
        this.label = this.scene.make.text({
            style: this.labelTextStyle,
        });
        this.label.setOrigin(0);
        // this.label.setScale(1.0);
        // this.label.setData("baseScale", this.label.scale);
        this.add(this.label);

        // NOTE: need to set 'some image' to get proper height (in parent)
        const tmpCardFrame: string = CardsManager.GetCardFrontFrameName(0,0);
        for (let i = 0; i<8; i++) {
            const imgCard = this.scene.make.image({key:LoaderFileKeys.cardsDeck, frame:tmpCardFrame});
            // imgCard.setOrigin(0);
            imgCard.scale = 0.8;
            this.imgCards.push(imgCard);
            this.add(imgCard);
        }
        
        this.imgDelimiterLine = this.scene.make.image({key: LoaderFileKeys.ui, frame:"rect-2x2-white.png"});
        this.imgDelimiterLine.setOrigin(0, 0.5);
        this.imgDelimiterLine.alpha = this.delimiterLineAlpha;
        this.add(this.imgDelimiterLine);
    }
    
    public SetData (
        label: string,
        cardsData: CardData[],
        hasDelimiterLine: boolean,
    ): void
    {
        this.label.text = label;
        this.hasDelimiterLine = hasDelimiterLine;
        this.imgDelimiterLine.visible = hasDelimiterLine;

        // set images
        for (let i:number = 0; i<this.imgCards.length; i++) {
            const cardImg = this.imgCards[i];
            const cardData = cardsData[i];
            const cardFrame = CardsManager.GetCardFrontFrameName(cardData.suit, cardData.rank);
            cardImg.setTexture(LoaderFileKeys.cardsDeck, cardFrame);
        }
    }
    
    public override SetWidthGetHeight(width: number): number
    {
        const height = this.labelPadding.top + this.labelPadding.bottom + this.label.displayHeight + this.imgCards[0].displayHeight + 2 * this.borderPadding.vertical;
        return height;
    }

    public override OnResize(): void
    {
        // console.log("DealsListItem::OnResize");
        
        // const centerX = this.size.width/2;
        // const centerY = this.size.height/2;
        // const item2PosX = this.borderPadding.width + this.elementReferenceWidth/2 + (this.size.width/2 - this.borderPadding.width - this.elementReferenceWidth/2)/2;
        // const item4PosX = this.size.width -this.borderPadding.width - this.elementReferenceWidth/2 - (this.size.width/2 - this.borderPadding.width - this.elementReferenceWidth/2)/2;

        // horizontal space for element
        const extraCardsBorderPaddingHorizontal = 54;
        const tmpCard = this.imgCards[0];
        const elementSpace = (this.size.width - 2 * this.borderPadding.horizontal - 2 * extraCardsBorderPaddingHorizontal) / 8;
        const halfElementSpace = elementSpace / 2;
        
        this.bg.setDisplaySize(this.size.width, this.size.height);

        // delimiter (if item has it -- last item in list does not have it)
        if (this.hasDelimiterLine) {
            // origin 0,1 (bot left)
            this.imgDelimiterLine.y = this.size.height;
            this.imgDelimiterLine.displayWidth = this.size.width;
        }

        // console.log(this.borderPadding, this.labelPadding)
        this.label.setPosition(
            this.borderPadding.horizontal + this.labelPadding.left,
            this.borderPadding.vertical + this.labelPadding.top,
        );
        
        const labelHeightTotal =this.borderPadding.vertical + this.labelPadding.top + this.label.displayHeight + this.labelPadding.bottom;
        for (let i = 0; i<this.imgCards.length; i++) {
            const cardImg = this.imgCards[i];
            cardImg.setPosition(
                extraCardsBorderPaddingHorizontal + this.borderPadding.horizontal + halfElementSpace + i * elementSpace, 
                labelHeightTotal + cardImg.displayHeight/2
            );
        }
    }
}